import React from "react";
import styles from "./headwithSubhead.module.css";
import { Col, Row } from "react-bootstrap";
import { useMyContext } from "../../myContext";
// src/component/signup/assets/resetIcon.svg
import resetIcon from "../../component/signup/assets/resetIcon.svg";

const HeadWithSubHead = ({ head, subHead, isResetButton }) => {
  // const { resetForm } = useMyContext();

  const onWindowReload = () => {
    // resetForm();
    window.location.reload();
  };

  return (
    <>
      <Row className={styles.containerbox}>
        <Col>
          <p className={styles.Heading}>{head}</p>
          <p className={styles.subHeading}>{subHead}</p>
        </Col>
        {isResetButton && (
          <div className={styles.buttonaddnew} onClick={onWindowReload}>
            <img src={resetIcon} alt=""></img>
            Reset Form
          </div>
        )}
      </Row>
      {/* <h1 className={styles.Heading}>{head}</h1>
        <p className={styles.subHeading}>{subHead}</p> */}
    </>
  );
};

export default HeadWithSubHead;
